import { ShieldCheck, Building2, MapPin } from "lucide-react";

export default function PolicyDetailsHeader({ policyType, providerName, coverLabel }) {
  return (
    <div className="flex flex-wrap gap-2">
      <span className="inline-flex items-center gap-1.5 rounded-full bg-emerald-50 px-3 py-1.5 text-sm font-semibold text-emerald-800 ring-1 ring-emerald-100">
        <ShieldCheck size={14} aria-hidden="true" />
        {policyType}
      </span>
      {providerName ? (
        <span className="inline-flex items-center gap-1.5 rounded-full bg-gray-50 px-3 py-1.5 text-sm font-medium text-gray-800 ring-1 ring-gray-200">
          <Building2 size={14} aria-hidden="true" />
          {providerName}
        </span>
      ) : null}
      {coverLabel ? (
        <span className="inline-flex items-center gap-1.5 rounded-full bg-orange-50 px-3 py-1.5 text-sm font-medium text-orange-800 ring-1 ring-orange-100">
          <MapPin size={14} aria-hidden="true" />
          {coverLabel}
        </span>
      ) : null}
    </div>
  );
}
